<template>
  <client-only>
    <v-layout
      column
      class="content-block cv-content dr-space-evenly"
      pt-1
      pl-2
      pr-2
    >
      <v-layout flex-grow-0 class="mb-2">
        <v-flex>
          <h6 class="display-16 mr-1 mt-1">
            <span v-show="cvFiles.length === 0">
              {{ cvPopup.chooseCVFile }}
            </span>

            <span v-show="cvFiles.length >= 1">
              {{ cvPopup.chooseCVFileSum }} {{ cvFiles.length }}
              {{ cvPopup.chooseFrom }} 4
            </span>
          </h6>
        </v-flex>

        <v-flex class="text-left">
          <label class="display-16 pointer p-relative">
            <span
              v-if="cvFiles.length < 4"
              v-show="!inProgress"
              class="hidden-xs-only underline"
            >
              {{ cvPopup.addNewFile }}
            </span>
            <v-icon
              v-show="!inProgress && cvFiles.length < 4"
              x-large
              class="icon-shape-1 display-22 v-align-text-top hidden-sm-and-up"
              color="primary"
              v-ripple="false"
            />
            <SmallSpinner
              v-show="inProgress"
              :top="-3"
              :left="13"
              :bg-gray="true"
            />
            <input
              v-show="false"
              id="file"
              ref="file"
              type="file"
              accept=".doc, .docx, .pdf, .rtf"
              @change="handleFileUpload"
            />
          </label>
        </v-flex>
      </v-layout>

      <v-layout v-show="cvFiles.length === 0" mb-2>
        <v-flex>
          <small class="red--text">
            <strong>{{ cvPopup.noCvAlertMessage }}</strong>
          </small>
        </v-flex>
      </v-layout>

      <v-layout v-if="showFiles" column class="toggle-cv-list flex-grow-0">
        <v-flex v-if="!displayList">
          <CVFileShortView
            :file="selectedFile"
            :class="{ displaySelected: selectedFile }"
          />
        </v-flex>
        <div v-else>
          <v-flex
            v-for="(file, index) in cvFiles"
            :key="index"
            class="cv-short-file"
          >
            <CVFileShortView
              :file="file"
              :allow-editing="allowEditing"
              :class="{ pointer: displayList }"
              @fileSelected="handleSelectCVFile"
            />
          </v-flex>
        </div>

        <v-flex
          v-if="displayShowBtn"
          xs12
          text-center
          ma-2
          class="flex-basis-auto"
        >
          <v-row>
            <v-col cols="8" md="8" lg="8">
              <p v-if="footerText" class="ma-0 text-right underline">
                <nuxt-link
                  :to="'/personal/cvfiles'"
                  target="_self"
                  class="black--text display-16"
                >
                  לניהול קבצי קו"ח באזור האישי
                </nuxt-link>
              </p>
            </v-col>

            <v-col cols="4" md="4" lg="4" class="text-left">
              <v-btn
                v-if="cvFiles.length !== 1 && !displayAll"
                ref="toggleCV"
                color="primary"
                rounded
                small
                :width="$vuetify.breakpoint.smAndUp ? 'auto' : '100px'"
                @click="toggleCVList"
                class="px-4 py-2"
              >
                הצג הכל
              </v-btn>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
      <p v-if="showCVError" class="red--text mt-2 mb-2">
        <strong v-html="cvErrorMsg" />
      </p>
      <!-- <p v-if="footerText" class="ma-0">
        <nuxt-link
          :to="'/personal/cvfiles'"
          target="_self"
          class="black--text caption"
        >
          לניהול קבצי קו"ח באזור האישי
        </nuxt-link>
      </p> -->
    </v-layout>
  </client-only>
</template>

<script>
import { isNil } from 'lodash';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import SmallSpinner from '@/components/Spinner/SmallSpinner';

import CVFileShortView from './CVFileShortView';
import CurrentUser from '@/components/mixins/CurrentUser';
import { UPLOAD_CV } from '@/lib/api.js';
import { gtm } from '../../../lib/gtm';

export default {
  mixins: [CurrentUser],
  components: {
    CVFileShortView,
    SmallSpinner,
  },

  props: {
    footerText: {
      type: Boolean,
      default: true,
      required: false,
    },
    displayAll: {
      type: Boolean,
      default: false,
      required: false,
    },
    displayShowBtn: {
      type: Boolean,
      default: true,
      required: false,
    },

    allowEditing: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  data() {
    return {
      cvPopup: t('titles.CV_Popup'),
      showAllFiles: false,
      selectedFile: undefined,
      showComponent: true,
      inProgress: false,
      showCVError: false,
      cvErrorMsg: null,
    };
  },

  computed: {
    showFiles() {
      return this.cvFiles.length > 0;
    },

    displayList() {
      return this.displayAll ? this.displayAll : this.showAllFiles;
    },

    cvFiles() {
      if (
        this.CurrentUser &&
        this.CurrentUser.Profile &&
        this.CurrentUser.Profile.CVsToDisplay
      ) {
        return this.CurrentUser.Profile.CVsToDisplay;
      }
      return [];
    },
  },

  mounted() {
    this.$nuxt.$emit('hideEditForm');
  },

  async fetch() {
    if (this.CurrentUser) {
      this.handleSelectCVFile(this.CurrentUser.Profile.DefaultCV);
    }
    this.showAllFiles = false;
  },
  methods: {
    handleSelectCVFile(file) {
      this.selectedFile = file;
      this.toggleCVList();
      this.$emit('fileChosen', this.selectedFile);
    },

    async handleFileUpload() {
      await this.uploadCV();
      await this.$auth.fetchUser();
      if (this.cvFiles && this.cvFiles.length >= 1) {
        this.handleSelectCVFile(this.cvFiles[0]);
      }
    },

    async uploadCV() {
      this.$nuxt.$loading.start();

      this.showCVError = false;
      this.file = this.$refs.file.files[0];
      /**
       * check file
       */
      if (!isNil(this.file)) {
        if (!/^.*\.(doc|DOC|docx|DOCX|pdf|PDF|rtf|RTF)$/.test(this.file.name)) {
          /**
           * TODO Add file name to message template
           */
          this.cvErrorMsg = t('titles.CV_Popup.CVFileNotSupported', {
            name: this.file.name,
          });
          this.showCVError = true;
          this.inProgress = false;
          this.$nuxt.$loading.finish();
          return false;
        } else if (this.file.size / 1000 > 4000) {
          this.cvErrorMsg = this.cvPopup.CVTooLargeErrorMessage;
          this.showCVError = true;
          this.inProgress = false;
          this.$nuxt.$loading.finish();

          return false;
        }
      }

      const formData = new FormData();
      this.inProgress = true;

      formData.append('filename', this.file);

      await this.$axios
        .post(`${UPLOAD_CV}`, formData)
        .then((res) => {
          if (res.data.IsError) {
            let value = Object.keys(res.data.Errors)[0];
            throw value;
            // throw res.data.Errors;
          }

          this.handleSelectCVFile(res.data.ResultList[0]);
          gtm({
            event: 'cv_upload'
          });
          this.inProgress = false;
          this.$nuxt.$loading.finish();
        })
        .catch((e) => {
          switch (e) {
            case 'CVFileExists':
              console.log('CVFileExists');
              this.cvErrorMsg = this.cvPopup.existingCVMsg;
              this.showCVError = true;
              this.inProgress = false;
              break;
            case 'CVFileCorrupted':
              console.log('CVFileCorrupted');
              this.cvErrorMsg = this.cvPopup.CVFileCorrupted;
              this.showCVError = true;
              this.inProgress = false;
              break;
            case 'CVFileNeededError':
              console.log('CVFileNeededError');
              this.cvErrorMsg = this.cvPopup.CVFileCorrupted;
              this.showCVError = true;
              this.inProgress = false;
              break;
            case 'UnsupportedMediaType':
              console.log('UnsupportedMediaType');
              this.cvErrorMsg = t('titles.CV_Popup.CVFileNotSupported', {
                name: this.file.name,
              });
              this.showCVError = true;
              break;
            default:
              this.cvErrorMsg = 'שגיאה';
              this.showCVError = true;
              this.inProgress = false;
              console.log('FAILURE!!', e);
              break;
          }
          this.$nuxt.$loading.finish();
        });
    },

    toggleCVList() {
      this.showAllFiles = !this.showAllFiles;
      return this.displayList;
    },
  },
};
</script>

<style lang="scss" scoped>
.cv-content {
  height: auto;
}

@media only screen and (min-width: 920px) {
}

@media only screen and (min-width: 600px) {
}
</style>
